import React, { useState } from "react";
import { NavLink, useLocation, useParams } from "react-router-dom";
import { CloseOutlined } from "@ant-design/icons";
import { Button, Drawer } from "antd";

import BrochureIcon from "../../assets/download_gif.gif";
// import logo from "../../assets/logo.svg";
import phone_extension from "../../assets/phone_extension.gif";
import Menu from "../../assets/MenuIcon.svg";

import useMapData from "../../utils/useMapData";

import "./Header.scss";
import useIcons from "../../utils/useIcons";

const Header = ({ onScroll, handleModalVisibility }) => {
  const [visible, setVisible] = useState(false);

  const { propertyId } = useParams();
  const resultList = useMapData(propertyId);

  const {
    AmmenitiesIcon,
    HomeIcon,
    LocationIcon,
    PriceIcon,
    SitePlanIcon,
    VirtualSiteTourIcon,
  } = useIcons();

  const { hash } = useLocation();

  const isHomePageActive = () => {
    if (!hash) {
      return true;
    }

    return hash === ("#overview" || "/");
  };

  const MenuIcon = () => {
    return <img src={Menu} alt="" />;
  };

  return (
    <>
      <div className="mainNavbarParent">
        <div className="mainNavbar">
          <div className="logo">
            <NavLink to="#overview" onClick={() => onScroll("overviewRef")}>
              <img src={resultList?.logoUrl} alt={resultList?.projectName} />
            </NavLink>
          </div>
          <div id="phone_extension">
            <a
              href={`tel:${resultList?.phonenumber}`}
              target="_blank"
              rel="noreferrer"
            >
              <img src={phone_extension} alt="" />
            </a>
            <Button
              onClick={() => setVisible(prevState => !prevState)}
              className="navbar__toggler"
            >
              {visible ? (
                <CloseOutlined
                  style={{
                    fontSize: "1.2em",
                    fontWeight: "600",
                    color: "#000",
                  }}
                />
              ) : (
                <MenuIcon />
              )}
            </Button>
          </div>
          <div className="navbar_links">
            <div style={{ borderLeft: "2px solid #ddd" }}></div>
            <NavLink to="#overview">
              <div
                className={`align_navlinks ${
                  isHomePageActive() ? "isActive" : ""
                }`}
                style={{
                  background: isHomePageActive()
                    ? resultList.themeColor || "#424242"
                    : "",
                }}
                onClick={() => onScroll("overviewRef")}
              >
                <HomeIcon />
              </div>
            </NavLink>
            <div style={{ borderLeft: "2px solid #ddd" }}></div>
            <NavLink to="#price">
              <div
                className={`align_navlinks ${
                  hash === "#price" ? "isActive" : ""
                }`}
                style={{
                  background:
                    hash === "#price" ? resultList.themeColor || "#424242" : "",
                }}
                onClick={() => onScroll("priceRef")}
              >
                <PriceIcon />
                Price
              </div>
            </NavLink>
            <div style={{ borderLeft: "2px solid #ddd" }}></div>
            <NavLink to="#sitePlan">
              <div
                className={`align_navlinks ${
                  hash === "#sitePlan" ? "isActive" : ""
                }`}
                style={{
                  background:
                    hash === "#sitePlan"
                      ? resultList.themeColor || "#424242"
                      : "",
                }}
                onClick={() => onScroll("sitePlanRef")}
              >
                <SitePlanIcon />
                Site Plan
              </div>
            </NavLink>
            <div style={{ borderLeft: "2px solid #ddd" }}></div>
            <NavLink to="#ammenities">
              <div
                className={`align_navlinks ${
                  hash === "#ammenities" ? "isActive" : ""
                }`}
                style={{
                  background:
                    hash === "#ammenities"
                      ? resultList.themeColor || "#424242"
                      : "",
                }}
                onClick={() => onScroll("ammenitiesRef")}
              >
                <AmmenitiesIcon />
                Ammenities
              </div>
            </NavLink>
            <div style={{ borderLeft: "2px solid #ddd" }}></div>
            <NavLink to="#location">
              <div
                className={`align_navlinks ${
                  hash === "#location" ? "isActive" : ""
                }`}
                style={{
                  background:
                    hash === "#location"
                      ? resultList.themeColor || "#424242"
                      : "",
                }}
                onClick={() => onScroll("locationRef")}
              >
                <LocationIcon />
                Location
              </div>
            </NavLink>
            <div style={{ borderLeft: "2px solid #ddd" }}></div>
            <NavLink to="#virtualTour">
              <div
                className={`align_navlinks ${
                  hash === "#virtualTour" ? "isActive" : ""
                }`}
                style={{
                  background:
                    hash === "#virtualTour"
                      ? resultList.themeColor || "#424242"
                      : "",
                }}
                onClick={() => onScroll("virtualTourRef")}
              >
                <VirtualSiteTourIcon />
                Virtual Site Tour
              </div>
            </NavLink>
            <div style={{ borderLeft: "2px solid #ddd" }}></div>
            <NavLink to="#download">
              <div
                className={`align_navlinks ${
                  hash === "#download" ? "isActive" : ""
                }`}
                style={{
                  background:
                    hash === "#download"
                      ? resultList.themeColor || "#424242"
                      : "",
                }}
                onClick={handleModalVisibility}
              >
                <img src={BrochureIcon} alt="" />
                Brochure
              </div>
            </NavLink>
          </div>
        </div>
      </div>

      {visible && (
        <Drawer
          placement="left"
          width={250}
          closable={false}
          onClose={() => setVisible(prevState => !prevState)}
          visible={visible}
        >
          <div className="drawer">
            <div className="logo">
              <NavLink to="#overview" onClick={() => onScroll("overviewRef")}>
                <img src={resultList.logoUrl} alt={resultList.projectName} />
              </NavLink>
            </div>
            <div className="navbar_links">
              <div style={{ borderLeft: "2px solid #ddd" }}></div>
              <NavLink to="#overview">
                <div
                  className={`align_navlinks ${
                    isHomePageActive() ? "isActive" : ""
                  }`}
                  style={{
                    background: isHomePageActive()
                      ? resultList.themeColor || "#424242"
                      : "",
                  }}
                  onClick={() => onScroll("overviewRef")}
                >
                  <HomeIcon />
                </div>
              </NavLink>
              <div style={{ borderLeft: "2px solid #ddd" }}></div>
              <NavLink to="#price">
                <div
                  className={`align_navlinks ${
                    hash === "#price" ? "isActive" : ""
                  }`}
                  style={{
                    background:
                      hash === "#price"
                        ? resultList.themeColor || "#424242"
                        : "",
                  }}
                  onClick={() => onScroll("priceRef")}
                >
                  <PriceIcon />
                  Price
                </div>
              </NavLink>
              <div style={{ borderLeft: "2px solid #ddd" }}></div>
              <NavLink to="#sitePlan">
                <div
                  className={`align_navlinks ${
                    hash === "#sitePlan" ? "isActive" : ""
                  }`}
                  style={{
                    background:
                      hash === "#sitePlan"
                        ? resultList.themeColor || "#424242"
                        : "",
                  }}
                  onClick={() => onScroll("sitePlanRef")}
                >
                  <SitePlanIcon />
                  Site Plan
                </div>
              </NavLink>
              <div style={{ borderLeft: "2px solid #ddd" }}></div>
              <NavLink to="#ammenities">
                <div
                  className={`align_navlinks ${
                    hash === "#ammenities" ? "isActive" : ""
                  }`}
                  style={{
                    background:
                      hash === "#ammenities"
                        ? resultList.themeColor || "#424242"
                        : "",
                  }}
                  onClick={() => onScroll("ammenitiesRef")}
                >
                  <AmmenitiesIcon />
                  Ammenities
                </div>
              </NavLink>
              <div style={{ borderLeft: "2px solid #ddd" }}></div>
              <NavLink to="#location">
                <div
                  className={`align_navlinks ${
                    hash === "#location" ? "isActive" : ""
                  }`}
                  style={{
                    background:
                      hash === "#location"
                        ? resultList.themeColor || "#424242"
                        : "",
                  }}
                  onClick={() => onScroll("locationRef")}
                >
                  <LocationIcon />
                  Location
                </div>
              </NavLink>
              <div style={{ borderLeft: "2px solid #ddd" }}></div>
              <NavLink to="#virtualTour">
                <div
                  className={`align_navlinks ${
                    hash === "#virtualTour" ? "isActive" : ""
                  }`}
                  style={{
                    background:
                      hash === "#virtualTour"
                        ? resultList.themeColor || "#424242"
                        : "",
                  }}
                  onClick={() => onScroll("virtualTourRef")}
                >
                  <VirtualSiteTourIcon />
                  Virtual Site Tour
                </div>
              </NavLink>
              <div style={{ borderLeft: "2px solid #ddd" }}></div>
              <NavLink to="#download">
                <div
                  className={`align_navlinks ${
                    hash === "#download" ? "isActive" : ""
                  }`}
                  style={{
                    background:
                      hash === "#download"
                        ? resultList.themeColor || "#424242"
                        : "",
                  }}
                  onClick={handleModalVisibility}
                >
                  <img src={BrochureIcon} alt="" />
                  Brochure
                </div>
              </NavLink>
            </div>
          </div>
        </Drawer>
      )}
    </>
  );
};

export default Header;
